import getTaskType from '../../utils/getTaskType';
import { formatDate, getDateFromDateString } from '../../utils/utils';

class TaskGlobal {
  constructor(task = {}) {
    this.id = task.id || '';
    this.extId = task.extId || '';

    this.type = task.type || getTaskType(true, false, false);

    this.title = task.title || '';
    this.subtitle = task.subtitle || '';
    this.description = task.description || '';
    this.note = task.note || '';

    this.startDate = task.startDate || formatDate();
    this.endDate = task.endDate || formatDate();

    // technical value for filter/sort
    this.date = this.endDate;

    this.importance = task.importance || false;
    this.done = task.done || false;

    this.delayedTaskId = task.delayedTaskId || null;

    this.labels = task.labels || [];

    // tasks structure
    this.tasksRegular = task.tasksRegular || [];
    this.tasksSingle = task.tasksSingle || [];
  }

  getCreateTaskGlobalDto() {
    const serverModel = {
      title: null,
      subTitle: null,
      description: null,
      note: null,
      isImportant: null,
      isDone: null,
      startDate: null,
      endDate: null,
      labels: [],
    };
    if (this.title) serverModel.title = this.title;
    if (this.subtitle) serverModel.subTitle = this.subtitle;
    serverModel.description = this.description;
    serverModel.note = this.note;
    if (this.startDate) serverModel.startDate = this.startDate;
    if (this.endDate) serverModel.endDate = this.endDate;
    if (this.labels) serverModel.labels = this.labels;
    serverModel.isImportant = this.importance || false;
    serverModel.isDone = this.done || false;
    Object.keys(serverModel).forEach((key) => {
      if (serverModel[key] === null) {
        delete serverModel[key];
      }
    });
    if (this.delayedTaskId) serverModel.delayedTaskId = this.delayedTaskId;
    return serverModel;
  }

  getTaskGlobal(serverModel) {
    this.id = serverModel.id || '';
    this.extId = serverModel.extId || '';

    this.type = getTaskType(true, false, false);

    this.title = serverModel.title || '';
    this.subtitle = serverModel.subTitle || '';
    this.description = serverModel.description || '';
    this.note = serverModel.note || '';

    this.startDate = serverModel.startDate ? getDateFromDateString(serverModel.startDate) : '';
    this.endDate = serverModel.endDate ? getDateFromDateString(serverModel.endDate) : '';

    // technical value for filter/sort
    this.date = this.endDate;

    this.importance = serverModel.isImportant || false;
    this.done = serverModel.isDone || false;

    this.labels = serverModel.labels || [];

    // tasks structure
    this.tasksRegular = serverModel.tasksRegular || [];
    this.tasksSingle = serverModel.tasksSingle || [];

    return this;
  }
}

export default TaskGlobal;
